import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class ApiBusinessService {

  private businessObject = new BehaviorSubject<any>(null);
  public businessStorage = this.businessObject.asObservable();

  private placeObject = new BehaviorSubject<any>(null);
  public placeStorage = this.placeObject.asObservable();

  private existChanges = new BehaviorSubject<any>(null);
  public changed = this.existChanges.asObservable();

  private businessChanges = new BehaviorSubject<any>(null);
  public businesSuperadmin = this.businessChanges.asObservable();

  constructor(private http: HttpClient) { }

  getBusinessStorage() {
    return this.businessChanges.getValue();
  }

  setBusinessStorage(business: any) {
    this.businessObject.next(business);
    localStorage.setItem('business', JSON.stringify(business));
  }

  setPlaceStorage(places: any) {
    this.placeObject.next(places);
    localStorage.setItem('places', JSON.stringify(places));
  }

  setChanges(places: any) {
    this.existChanges.next(places);
  }

  setBusinessSuperAdmin(company: any) {
    this.businessChanges.next(company);
  }

  getAllBusinessAdmin(page: number, search: string | null, sort: any) {
    let url = `${AppSettings.API_URI_V2}/companies?page=${page}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (sort) {
      url += `&orderBy=${sort.sortedBy}&order=${sort.sort}`;
    }
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  setBusinessById(idBusiness: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/admin/companies/${idBusiness}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  //V2
  getCompanyByUser(userId: number) {
    const url = `${AppSettings.API_URI_V2}/companies?id_user=${userId}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getCompanyById(businessId: number) {
    const url = `${AppSettings.API_URI_V2}/companies/find/${businessId}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  setBusinessSimpleInfo(idBusiness: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/admin/companies/${idBusiness}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }
}
